export const GOOGLE_RESERVATIONS_QUEUES = {
	SEND_REALTIME_UPDATE: 'send-realtime-update',
	UPLOAD_MERCHANT_FEED: 'upload-merchant-feed',
	UPLOAD_SERVICES_FEED: 'upload-services-feed',
	UPLOAD_AVAILABILITY_FEED: 'upload-availability-feed',
}
